import { useState } from 'react';
import { Link } from 'react-router-dom';
import { videos } from '@/mocks/data';

export default function HotRecommend() {
  const hotVideos = videos.filter((v) => v.isHot);
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">全网最受欢迎的视频内容，大家都在看</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setHoveredId(video.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className={`w-full h-full object-cover transition-transform duration-500 ${
                    hoveredId === video.id ? 'scale-110' : 'scale-100'
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="px-2 py-1 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium whitespace-nowrap">
                    {video.duration}
                  </span>
                  <span className="px-2 py-1 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium whitespace-nowrap">
                    {video.views}次播放
                  </span>
                </div>
                <div className={`absolute inset-0 bg-black/30 flex items-center justify-center transition-opacity duration-300 ${
                  hoveredId === video.id ? 'opacity-100' : 'opacity-0'
                }`}>
                  <div className="w-14 h-14 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl w-6 h-6 flex items-center justify-center ml-0.5"></i>
                  </div>
                </div>
                {video.isNew && (
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    NEW
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-1 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{video.description}</p>
                <div className="flex items-center gap-2">
                  <span className="flex items-center gap-1 text-xs text-amber-500">
                    <i className="ri-star-fill w-3 h-3 flex items-center justify-center"></i>
                    {video.rating}
                  </span>
                  <span className="text-foreground-400 text-xs">|</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}